import React from "react";
import { CheckCircleFilled, WarningFilled } from "@ant-design/icons";
import { SecurePassAutoSendMap } from "@/utils/enum";
import TooltipWrapper from "@/components/TooltipWrapper/TooltipWrapper";

const SecurePassAddressSetting = ({ autoSendSecurePassLevel, contactEmail }) => (
  <>
    <span className="span-click">
      SecurePass: <b>{SecurePassAutoSendMap[autoSendSecurePassLevel] ?? "Not Set"}</b>
    </span>
    <br />
    {contactEmail ? (
      <>
        <span>
          Contact:{" "}
          <b>
            <TooltipWrapper text={contactEmail} maxLength={20} />
          </b>
        </span>
        <CheckCircleFilled style={{ color: "#52c41a", marginLeft: 5 }} />
      </>
    ) : (
      <>
        <span>
          Contact: <b>Not Set</b>
        </span>
        <WarningFilled style={{ color: "#faad14", marginLeft: 5 }} />
      </>
    )}
  </>
);

export default SecurePassAddressSetting;
